import React, { useState, useEffect } from 'react';

// Full-page loading state: a skeleton of the screen (eyebrow, title, hero,
// two cards) instead of a spinner, so the layout doesn't jump on arrival.
function Loading({ message = 'Loading...' }) {
  const [showSlowMessage, setShowSlowMessage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSlowMessage(true);
    }, 3000); // Show message after 3 seconds
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="pnp-skeleton-screen" role="status" aria-live="polite" aria-busy="true">
      <span className="sr-only">{message}</span>
      <div className="pnp-skel" style={{ width: 110, height: 12, borderRadius: 999 }} />
      <div className="pnp-skel" style={{ width: '62%', maxWidth: 360, height: 42, borderRadius: 10 }} />
      <div className="pnp-skel" style={{ height: 220, borderRadius: 'var(--radius-card)', marginTop: 22 }} />
      <div className="pnp-skel" style={{ height: 96, borderRadius: 'var(--radius-card)' }} />
      <div className="pnp-skel" style={{ height: 96, borderRadius: 'var(--radius-card)' }} />
      {showSlowMessage && (
        <p className="pnp-loading-note">
          Server is waking up, please wait...
        </p>
      )}
    </div>
  );
}

export default Loading;
